<template>
    <form @submit.prevent="submit()" class="d-inline">
        <quantity v-model="newQuantity"></quantity>
    </form>
</template>

<script>
import Quantity from "./Quantity";
import {debounce} from "lodash";
import {EventBus} from "../../events";

export default {
    name: "cart-quantity-update",
    components: {
        Quantity
    },
    props: {
        cartItem: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            newQuantity: 0,
            submitted: false,
            processed: false,
        }
    },
    computed: {
        currentQuantity() {
            if (this.cartItem) {
                return this.cartItem.amount;
            }
            return 0;
        },
        isDirty() {
            return (parseInt(this.currentQuantity) !== parseInt(this.newQuantity));
        }
    },
    methods: {
        checkFieldForEmptyValue() {
            if (!this.submitted && this.newQuantity === '') {
                this.reset();
            }
        },
        reset() {
            this.newQuantity = this.currentQuantity;
        },
        update: debounce((vm) => {
            vm.submit();
        }, 500),
        submit() {
            if (this.isDirty && this.newQuantity !== '') {
                // update:
                if (!this.submitted) {
                    this.submitted = true;
                    if(this.newQuantity === 0){
                        EventBus.$emit('destroyLine', (this.cartItem.id));
                    }
                    else {
                        this.$store.dispatch('cart/updateQuantity', {
                            cart_item_id: this.cartItem.id,
                            quantity: this.newQuantity
                        }).then((response) => {
                            if(response.data.error !== "") {
                                window.flash(response.data.error, 'danger');
                            }
                        }).catch(error => {
                            // todo: what to do with this error?
                            if (error.response) {
                                if (error.response.data.errors.quantity) {
                                    window.flash(error.response.data.errors.quantity[0], 'danger');
                                }
                            }
                        }).finally(() => {
                            this.submitted = false;
                        });
                    }
                }
            }
        },
    },
    mounted() {
        this.reset();
    },
    watch: {
        cartItem() {
            this.reset();
        },
        newQuantity() {
            this.update(this);
        }
    }
}
</script>

<style scoped>
.amountInput{
    -webkit-appearance: textfield;
    border-radius: 0;
}

.btn-number {
    margin: 0;
}
</style>
